import { jsxs, jsx } from "react/jsx-runtime";
function FullScreenIcon() {
  const size = "24";
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: size,
      height: size,
      viewBox: `0 0 ${size} ${size}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M 9.395194,12.624803 5.43497,16.585027 3.200257,14.350315 v 6.449324 h 6.449325 l -2.234714,-2.234712 3.960224,-3.960222 z",
            fill: "white",
            id: "arrow"
          }
        ),
        /* @__PURE__ */ jsx(
          "use",
          {
            x: "0",
            y: "0",
            xlinkHref: "#arrow",
            transform: "rotate(180,12,12)",
            width: "100%",
            height: "100%"
          }
        )
      ]
    }
  );
}
export {
  FullScreenIcon
};
//# sourceMappingURL=index.js.map
